import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { CheckCircle } from "lucide-react";

export const MilestoneRoadmap = ({ milestones }) => {
  return (
    <div className="relative max-w-6xl mx-auto">
      {/* Vertical Timeline for Mobile, Horizontal for Desktop */}
      <div className="hidden md:block">
        {/* Horizontal Roadmap */}
        <div className="relative">
          {/* Central connecting line */}
          <div className="absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-600 transform -translate-y-1/2" />

          {/* Milestones in a zigzag pattern */}
          <div className="grid grid-cols-1 gap-6">
            {milestones.map((milestone, index) => {
              const isEven = index % 2 === 0;
              const yearsSinceStart = parseInt(milestone.year) - 1977;
              const progressPercent = (yearsSinceStart / 50) * 100;

              return (
                <div key={index} className="relative">
                  <div
                    className={`flex ${isEven ? "flex-col" : "flex-col-reverse"} items-center gap-4`}
                  >
                    {/* Card */}
                    <Card className="w-full md:w-80 border-2 border-amber-200 hover:border-amber-400 hover:shadow-2xl transition-all duration-300 group">
                      <CardContent className="p-5">
                        <div className="flex items-start gap-3">
                          {/* Year Badge */}
                          <div className="flex-shrink-0">
                            <Badge className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-3 py-1 text-sm font-bold">
                              {milestone.year}
                            </Badge>
                          </div>
                          
                          <div className="flex-1">
                            <h4 className="font-bold text-slate-900 mb-2 group-hover:text-amber-700 transition-colors">
                              {milestone.event}
                            </h4>
                            <p className="text-sm text-slate-600 leading-relaxed">
                              {milestone.description}
                            </p>
                          </div>

                          {/* Check icon */}
                          <CheckCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-1" />
                        </div>
                      </CardContent>
                    </Card>

                    {/* Connecting dot */}
                    <div className="relative flex items-center justify-center">
                      <div className="w-6 h-6 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 shadow-lg border-4 border-white z-10" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Mobile/Tablet Vertical Timeline */}
      <div className="md:hidden">
        <div className="relative pl-8">
          {/* Vertical line */}
          <div className="absolute left-3 top-0 bottom-0 w-1 bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600" />

          {/* Milestones */}
          <div className="space-y-8">
            {milestones.map((milestone, index) => (
              <div key={index} className="relative">
                {/* Dot */}
                <div className="absolute -left-5 top-3 w-6 h-6 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 shadow-lg border-4 border-white z-10" />

                {/* Card */}
                <Card className="border-2 border-amber-200 hover:border-amber-400 hover:shadow-xl transition-all duration-300">
                  <CardContent className="p-4">
                    <Badge className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-2 py-1 text-xs font-bold mb-2">
                      {milestone.year}
                    </Badge>
                    <h4 className="font-bold text-slate-900 mb-2">
                      {milestone.event}
                    </h4>
                    <p className="text-sm text-slate-600 leading-relaxed">
                      {milestone.description}
                    </p>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Progress indicator */}
      <div className="mt-12 text-center">
        <div className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-amber-50 to-amber-100 rounded-full border-2 border-amber-300">
          <div className="w-3 h-3 rounded-full bg-amber-600 animate-pulse" />
          <span className="text-sm font-semibold text-amber-900">
            Continuing Innovation Since 1977
          </span>
        </div>
      </div>
    </div>
  );
};
